import { Component, OnInit } from "@angular/core";
import { SeoService } from "src/app/services/seo.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { Router } from "@angular/router";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Component({
  selector: "v2m-learning",
  templateUrl: "./learning.component.html",
  styleUrls: ["./learning.component.scss"],
})
export class LearningComponent implements OnInit {
  promotionApiUrl = "https://api.video2manual.de/promotions/extendlearningkey";
  newsletterApiUrl = "https://api.video2manual.de/newsletters/register";
  licensekey = "";
  salutation = "";
  lastname = "";
  firstname = "";
  email = "";
  company = "";
  privacy = false;
  newsletter = false;
  isCreating = false;
  isCreated = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private seo: SeoService
  ) {}

  ngOnInit() {
    this.seo.updateTitle("video2manual - Download");
    this.seo.updateKeywords("Download,Testversion");
  }

  send() {
    const request = {
      Offer: "extend-learning-license",
      LicenseKey: this.licensekey,
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      CompanyName: this.company,
    };

    this.isCreating = true;

    this.http
      .post(this.promotionApiUrl, request, httpOptions)
      .pipe(catchError(this.handleError<any>("requestdownlaod")))
      .subscribe((_) => {
        this.isCreating = false;
        this.isCreated = true;
      });

    if (this.newsletter) {
      this.requestNewsletter();
    }
  }

  gotoHome() {
    this.router.navigate(["/"]);
  }

  private requestNewsletter() {
    const request = {
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      CompanyName: this.company,
      RegistrationMethod: "Website",
    };

    this.http
      .post(this.newsletterApiUrl, request, httpOptions)
      .subscribe((_) => {
        console.log("Newsletter request was sended");
      });
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      return of(result as T);
    };
  }
}
